<app-spinner [show]="showSpinner"></app-spinner>


<!-- Search Box Layout -->
<div class="search-overlay">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="search-overlay-layer"></div>
            <div class="search-overlay-layer"></div>
            <div class="search-overlay-layer"></div>

            <div class="search-overlay-close">
                <span class="search-overlay-close-line"></span>
                <span class="search-overlay-close-line"></span>
            </div>

            <div class="search-overlay-form">
                <form>
                    <input type="text" class="input-search" placeholder="Search here...">
                    <button type="submit"><i class='bx bx-search-alt'></i></button>
                </form>
            </div>
        </div>
    </div>
</div>
<!-- End Search Box Layout -->
<!-- Start Main Banner -->
<div class="hero-banner" [style.background]="background">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container-fluid">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-12">
                        <div class="hero-banner-content" >
                            <span class="sub-title">{{slideTitle}}</span>
                            <h1>{{slideTitleHeader}}</h1>
                            <p>{{slideDesc}}</p>
                            <div class="btn-box">
                                <a routerLink="/courses" class="default-btn"><i
                                        class='bx bx-move-horizontal icon-arrow before'></i><span class="label">{{viewCourses}}</span><i class="bx bx-move-horizontal icon-arrow after"></i></a>
                                <a routerLink="/my-account/courses" class="optional-btn">{{getStartFree}}</a>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-12" *ngIf="setting">
                        <div class="hero-banner-image text-center">
                            <img id="bubble-img" src="{{setting.slideForegroundImage.fileUrl}}" alt="image">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Main Banner -->
<!-- Start Boxes Area -->
<!-- <section class="boxes-area">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-3 col-md-6">
                <div class="single-boxes-item">
                    <h3>Learn The Latest Skills</h3>
                    <p>Like business analytics, graphic design, Python, and more.</p>
                    <a href="courses-2-columns-style-1.html" class="boxes-btn">View Courses<i
                            class='bx bx-plus'></i></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-boxes-item bg-image">
                    <h3>100k Online Courses</h3>
                    <p>In high-demand fields like IT, AI and cloud engineering.</p>
                    <a href="courses-2-columns-style-2.html" class="boxes-btn">View More<i class='bx bx-plus'></i></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-boxes-item bg-color">
                    <h3>Earn a Certificate</h3>
                    <p>From a leading university in business, computer science, and more.</p>
                    <a href="courses-3-columns-style-1.html" class="boxes-btn">View Courses<i
                            class='bx bx-plus'></i></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-boxes-item">
                    <h3>Up Your Skill</h3>
                    <p>With on-demand training and development programs.</p>
                    <a href="courses-4-columns-style-1.html" class="boxes-btn">View More<i class='bx bx-plus'></i></a>
                </div>
            </div>
        </div>
    </div>
</section> -->
<!-- End Boxes Area -->
<!-- Start Courses Area -->
<section class="courses-area ptb-100">
    <div class="container">
        <div class="section-title text-left">
            <span class="sub-title">{{discoverCourses}}</span>
            <h2>{{popularCourses}}</h2>
            <a routerLink="/courses" class="default-btn"><i class='bx bx-show-alt icon-arrow before'></i><span
                    class="label">{{allCourses}}</span><i class="bx bx-show-alt icon-arrow after"></i></a>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6" *ngFor="let course of courses">
                <app-course-item [course]="course" (routeToCourseDetail)="routeToCourseDetail($event)">
                </app-course-item>
            </div>
        </div>
    </div>
</section>
<!-- End Courses Area -->
<!-- Start Mission Area -->
<section class="mission-area ptb-100 jarallax" data-jarallax='{"speed": 0.3}'>
    <div class="container">
        <div class="mission-content">
            <div class="section-title text-left">
                <h2>
                    {{translate("Why Cam-Edu?", "ហេតុអ្វីជ្រើសរើស Cam-Edu?")}}
                </h2>
            </div>

            <div class="mission-slides owl-carousel owl-theme">

                <div>
                    <h3>
                        {{translate("Quality Courses", "វគ្គសិក្សាដែលមានគុណភាព")}}
                    </h3>
                    <p>
                        {{translate(
                            "Carefully prepared English courses with structured lessons, practical activities, and useful learning resources.",
                            "វគ្គសិក្សាភាសាអង់គ្លេសត្រូវបានរៀបចំយ៉ាងយកចិត្តទុកដាក់ ជាមួយមេរៀនដែលមានរចនាសម្ព័ន្ធច្បាស់លាស់ សកម្មភាពអនុវត្តជាក់ស្តែង និងធនធានសិក្សាដែលមានប្រយោជន៍។"
                        )}}
                    </p>
                </div>

                <div>
                    <h3>
                        {{translate(
                            "Qualified & Experienced Instructors",
                            "គ្រូបង្រៀនមានសមត្ថភាព និងបទពិសោធន៍"
                        )}}
                    </h3>
                    <p>
                        {{translate(
                            "Learn from dedicated instructors who provide clear explanations, practical examples, and guidance to help you improve your English.",
                            "សិក្សាជាមួយគ្រូបង្រៀនដែលយកចិត្តទុកដាក់ ដោយផ្តល់ការពន្យល់យ៉ាងច្បាស់លាស់ ឧទាហរណ៍ជាក់ស្តែង និងការណែនាំដើម្បីជួយអ្នកអភិវឌ្ឍជំនាញភាសាអង់គ្លេស។"
                        )}}
                    </p>
                </div>

                <div>
                    <h3>
                        {{translate(
                            "Learn Anytime, Anywhere",
                            "រៀនបានគ្រប់ពេលវេលា និងគ្រប់ទីកន្លែង"
                        )}}
                    </h3>
                    <p>
                        {{translate(
                            "Access your English lessons online whenever and wherever it is convenient for you.",
                            "ចូលរៀនមេរៀនភាសាអង់គ្លេសតាមអនឡាញបានគ្រប់ពេល និងគ្រប់ទីកន្លែងតាមភាពងាយស្រួលរបស់អ្នក។"
                        )}}
                    </p>
                </div>

                <div>
                    <h3>
                        {{translate(
                            "Learn at Your Own Pace",
                            "រៀនតាមល្បឿនរបស់អ្នក"
                        )}}
                    </h3>
                    <p>
                        {{translate(
                            "Study whenever you have time and review lessons as often as you need.",
                            "រៀននៅពេលដែលអ្នកមានពេលទំនេរ និងអាចមើលរំលឹកមេរៀនឡើងវិញបានគ្រប់ពេលតាមតម្រូវការរបស់អ្នក។"
                        )}}
                    </p>
                </div>

                <div>
                    <h3>
                        {{translate(
                            "Affordable Education",
                            "ការអប់រំដែលមានតម្លៃសមរម្យ"
                        )}}
                    </h3>
                    <p>
                        {{translate(
                            "Make quality English learning more accessible without the high cost of traditional classes.",
                            "ទទួលបានការសិក្សាភាសាអង់គ្លេសប្រកបដោយគុណភាពក្នុងតម្លៃសមរម្យ ដោយមិនចាំបាច់ចំណាយថ្លៃខ្ពស់ដូចការសិក្សាតាមថ្នាក់បែបប្រពៃណី។"
                        )}}
                    </p>
                </div>

                <div>
                    <h3>
                        {{translate(
                            "Designed for Cambodian Learners",
                            "រៀបចំឡើងសម្រាប់អ្នកសិក្សាជនជាតិខ្មែរ"
                        )}}
                    </h3>
                    <p>
                        {{translate(
                            "Enjoy learning experiences designed around the needs of English learners in Cambodia.",
                            "ទទួលបានបទពិសោធន៍សិក្សាដែលត្រូវបានរៀបចំឡើងដោយផ្អែកលើតម្រូវការរបស់អ្នកសិក្សាភាសាអង់គ្លេសនៅកម្ពុជា។"
                        )}}
                    </p>
                </div>

                <div>
                    <h3>
                        {{translate(
                            "Student Community",
                            "សហគមន៍អ្នកសិក្សា"
                        )}}
                    </h3>
                    <p>
                        {{translate(
                            "Join a growing community of 2,000+ students with 4,000+ course enrollments.",
                            "ចូលរួមជាមួយសហគមន៍អ្នកសិក្សាដែលកំពុងរីកចម្រើន មានសិស្សជាង 2,000 នាក់ និងការចុះឈ្មោះចូលរៀនវគ្គសិក្សាជាង 4,000 ដង។"
                        )}}
                    </p>
                </div>

                <div>
                    <h3>
                        {{translate(
                            "Learn for Your Future",
                            "រៀនសម្រាប់អនាគតរបស់អ្នក"
                        )}}
                    </h3>
                    <p>
                        {{translate(
                            "Improve your English for school, exams, scholarships, work, and future career opportunities.",
                            "អភិវឌ្ឍជំនាញភាសាអង់គ្លេសរបស់អ្នកសម្រាប់ការសិក្សា ការប្រឡង អាហារូបករណ៍ ការងារ និងឱកាសអាជីពនាពេលអនាគត។"
                        )}}
                    </p>
                </div>

            </div>
        </div>
    </div>
</section>
<!-- End Mission Area -->

<!-- Start Courses Categories Area -->
<section class="courses-categories-area bg-image pt-100 pb-70">
    <div class="container">
        <div class="section-title text-left">
            <span class="sub-title">{{englishLessonsCourses}}</span>
            <h2>{{browseTrendingCourses}}</h2>
            <a routerLink="/lessons" class="default-btn"><i class='bx bx-show-alt icon-arrow before'></i><span
                    class="label">{{viewAll}}</span><i class="bx bx-show-alt icon-arrow after"></i></a>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6" *ngFor="let course of englishCourses">
                <app-english-course-item [course]="course"></app-english-course-item>
            </div>
        </div>

    </div>

    <div id="particles-js-circle-bubble-2"></div>
</section>
<!-- End Courses Categories Area -->

<!-- Start Partner Area -->
<section class="partner-area pt-100">
    <div class="container">
        <div class="section-title">
            <h2>{{ourPartner}}</h2>
        </div>

        <div class="row">
            <div class="col-lg-2 col-md-2 col-sm-2" *ngFor="let partner of partners">
                <a target="_blank" href="{{partner.link}}" class="d-block text-center">
                    <img  src="{{partner.image.fileUrl}}" alt="image">
                </a>
            </div>
        </div>
    </div>
</section>
<!-- End Partner Area -->
<!-- Start Team Area -->
<section class="team-area ptb-100">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">{{makeConnections}}</span>
            <h2>{{teamInstructor}}</h2>
            <!-- <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et
                dolore
                magna aliqua. Ut nisi ut aliquip ex ea.</p> -->
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6" *ngFor="let teacher of teachers">
                <app-teacher-item (routeToTeacherDetail)="routeToTeacherDetail($event)" [teacher]="teacher">
                </app-teacher-item>
            </div>

            <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="team-btn-box text-center">
                    <a routerLink="/instructors" class="default-btn"><i
                            class='bx bx-show-alt icon-arrow before'></i><span class="label">{{allInstructor}}</span><i class="bx bx-show-alt icon-arrow after"></i></a>
                </div>
            </div>
        </div>
    </div>

    <div id="particles-js-circle-bubble-3"></div>
</section>
<!-- End Team Area -->

<!-- Start Offer Area -->
<section class="offer-area pt-100 jarallax" data-jarallax='{"speed": 0.3}'>
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Make Connections</span>
            <h2>What We Offer For Growth</h2>
            <!-- <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et
                dolore
                magna aliqua. Ut nisi ut aliquip ex ea.</p> -->
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-offer-box">
                    <div class="icon">
                        <i class='bx bx-book-reader'></i>
                    </div>
                    <h3>{{provideResources}}</h3>
                    <p>{{provideResourcesText}}</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-offer-box">
                    <div class="icon">
                        <i class='bx bx-target-lock'></i>
                    </div>
                    <h3>{{empowerLearner}}</h3>
                    <p>{{empowerLearnerText}}</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                <div class="single-offer-box">
                    <div class="icon">
                        <i class='bx bxs-thermometer'></i>
                    </div>
                    <h3>{{thinkBig}}</h3>
                    <p>{{thinkBigText}}</p>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Offer Area -->

<!-- Start Blog Area -->
<section class="blog-area pt-100 pb-70">
    <div class="container">
        <div class="section-title text-left">
            <span class="sub-title">{{exploreNews}}</span>
            <h2>{{latestKnowledges}}</h2>
            <a routerLink="/knowledges" class="default-btn"><i class='bx bx-book-reader icon-arrow before'></i><span
                    class="label">{{readAll}}</span><i class="bx bx-book-reader icon-arrow after"></i></a>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6" *ngFor="let knowledge of knowledges">
                <app-knowledge-item [knowledge]="knowledge" (routeToTeacherDetail)="routeToTeacherDetail($event)">
                </app-knowledge-item>
            </div>
        </div>
    </div>
</section>
<!-- End Blog Area -->

<!-- Start Become Instructor & Partner Area -->
<app-become-instructor></app-become-instructor>
<!-- End Become Instructor & Partner Area -->